module.exports = __webpack_public_path__ + "img/watch.d6bf3c04.svg";